export default "__VITE_ASSET__4e1e4a1a__"